import http from './axios'
import qs from 'qs'
export function getData(url = '', params = {}) {
    let Promise = http.get(url, {
        params: params
    }).then(res => {
        return res.data
    })
    return Promise
}



export function postData(url = '', params = {}) {
    let promise = http.post(url, qs.stringify(params)        
    ).then(res => {
        return res.data
    }).catch(err => {
        console.log(err)
    })
    return promise
}